import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {Session} from 'src/app/interfaces/session-data';
import {Router} from '@angular/router';
import {catchError, tap} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(private router: Router) {}

  session: Session;

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow
    if (err.status === 401 || err.status === 403) {
      //navigate /delete cookies or whatever

      // Basic err message example: Oops something went wrong
      // Button to go back to merchant
      // Brief description, e.g could not reach the server

      // Auth Error
      this.router.navigate(['error'], { queryParams: { error: 'Oops something went wrong!', errorDescription: "We couldn't process your request, please return to the merchant and try again" } });
      return throwError(err);
    }
  }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const authToken = sessionStorage.getItem('authToken');

    if (authToken && authToken.length > 0) {

      let cloned = req;
      if (!req.headers.get('Authorization')) {

        cloned = req.clone({
          headers: req.headers.set(
            "Authorization",
            `Bearer ${authToken}`
          )
        });

      }

      return next.handle(cloned)
        .pipe(
          tap(event => {
            if (event instanceof HttpResponse) {
              if (event.url.indexOf('/channel-virtual/api/v1/secure-eft/transaction/') > -1) {
                sessionStorage.setItem("transaction-status-eft", event.status.toString());
              } else if (event.url.indexOf('/channel-virtual/api/v1/mobicred/') > -1) {
                sessionStorage.setItem("transaction-status-mobicred", event.status.toString());
              }
              return next.handle(cloned);
              //}
            }
          }, (error: HttpErrorResponse) => {
            if (error.status === 404) {
              // -- Not Found --
              //this.router.navigate(['error'], { queryParams: { error: 'Not Found', errorDescription: "We could not find the resource you requested" } });
              return next.handle(cloned);
            } else if (error.status === 401) {
              // -- User has invalid an invalid/expired token --
              if (error.url.indexOf('mobicred/initialize') > -1	|| error.url.indexOf('/secure-eft/transaction/') > -1 ) {
                return next.handle(cloned);
              } else {
                this.router.navigate(['error'], { queryParams: { error: 'Unauthorized', errorDescription: "Invalid Session Data, please try again" } });
              }
            } else if (error.status === 403) {
              // -- User has insufficient permissions --
              this.router.navigate(['error'], { queryParams: { error: 'Forbidden', errorDescription: "Invalid Authentication" } });
            } else if (error.status === 412 || error.status === 409) {
              return next.handle(cloned);
            } else if (error.status === 400) {
              // -- Bad Request --
              // if (error.url.indexOf('mobicred/validate') > -1	|| error.url.indexOf('mobicred/otp') > -1 || error.url.indexOf('/otp') > -1) {
              // 	return next.handle(cloned);
              // } else {
              // 	this.router.navigate(['error'], { queryParams: { error: 'Unauthorized', errorDescription: "Invalid Session Data, please try again" } });
              // }
              // this.router.navigate(['error'], { queryParams: { error: 'Bad Request', errorDescription: "Invalid Request, please try again" } });
              return next.handle(cloned);
            } else if (error.status === 425) {
              return next.handle(cloned);
            } else {
              // -- General unhandled exception error --
              // -- Not sure if 500's should be explicitly handled or handled in generic error handled --
              if (error.status === 500) {
                return next.handle(cloned);
              } else {
                this.router.navigate(['error'], { queryParams: { error: 'Oops something went wrong!', errorDescription: "We couldn't process your request, please return to the merchant and try again" } });
              }
            }
          })
        )
    } else {
      return next.handle(req).pipe(catchError(x=> this.handleAuthError(x))); //here use an arrow function, otherwise you may get "Cannot read property 'navigate' of undefined" on angular 4.4.2/net core 2/webpack 2.70
    }
  }



}
